let apiVersion;

if (
    window.location.host === "localhost:3000" ||
    window.location.host === "dev.urgidoctor.com"
) {
    apiVersion = process.env.REACT_APP_API_URL_QA;
} else if (window.location.host === "staging.urgidoctor.com") {
    apiVersion = process.env.REACT_APP_API_URL_QA;
} else if (window.location.host === "app.urgidoctor.com") {
    apiVersion = process.env.REACT_APP_API_URL;
}

let dosespotApiVersion = process.env.REACT_APP_DOSESPOT_URL;

export const loginUrl = `${apiVersion}/api/user/login`;
export const emailVerificationUrl = `${apiVersion}/api/user/emailVerification`;
export const verifyEmailUrl = `${apiVersion}/api/user/verifyEmail`;
export const signUpUrl = `${apiVersion}/api/user/signup`;
export const forgotPasswordRequestUrl = `${apiVersion}/api/user/forgotPasswordRequest`;
export const confirmPasswordRequestUrl = `${apiVersion}/api/user/confirmPasswordRequest`;
export const signOutUrl = `${apiVersion}/api/user/logout`;

export const getSpecialityListUrl = `${apiVersion}/api/doctor/getSpecialityList/`;
export const getLanguageListUrl = `${apiVersion}/api/user/getLanguageList/`;
export const getDegreeListUrl = `${apiVersion}/api/doctor/getDegreeList/`;
export const getAppThemeListUrl = `${apiVersion}/api/doctor/getAppThemeList/`;

export const getNotificationsUrl = page =>
    `${apiVersion}/api/user/getNotifications?page=${page}`;

export const saveDoctorDetailsUrl = `${apiVersion}/api/doctor/addDoctorDetails`;
export const getDoctorDetailsUrl = `${apiVersion}/api/doctor/getDoctorDetails/`;

export const saveDoctorPracticeDetailsUrl = `${apiVersion}/api/doctor/addDoctorPracticeDetails`;
export const saveDoctorDocumentUrl = `${apiVersion}/api/doctor/addDoctorDocument`;
export const addDoctorAppThemeUrl = `${apiVersion}/api/doctor/addDoctorAppTheme`;

export const updateUserUrl = userId =>
    `${apiVersion}/api/user/updateUser/${userId}/`;

export const updateProfileImageUrl = userId =>
    `${apiVersion}/api/user/updateProfileImage/${userId}/`;

export const updateDoctorSignatureUrl = doctorDetailId =>
    `${apiVersion}/api/doctor/uploadDoctorSignature/${doctorDetailId}/`;

export const updateDoctorQrCodeUrl = doctorDetailId =>
    `${apiVersion}/api/doctor/updateDoctorQrCode/${doctorDetailId}/`;

export const updateNotificationStatusUrl = notificationId =>
    `${apiVersion}/api/user/updateNotificationStatus/${notificationId}/`;

export const deleteNotificationUrl = notificationId =>
    `${apiVersion}/api/user/removeNotification/${notificationId}/`;

export const updatePCPStatusUrl = pcpId =>
    `${apiVersion}/api/patient/updatePCPStatus/${pcpId}/`;

export const updateDoctorDetailUrl = userId =>
    `${apiVersion}/api/doctor/updateDoctorDetail/${userId}/`;

export const updateDoctorPracticeDetailsUrl = userId =>
    `${apiVersion}/api/doctor/updateDoctorPracticeDetails/${userId}/`;

export const updateDoctorDocumentUrl = docuemntId =>
    `${apiVersion}/api/doctor/updateDoctorDocument/${docuemntId}/`;

export const addDoctorUnavailabilityUrl = () =>
    `${apiVersion}/api/appointment/addDoctorUnavailability/`;

export const updateDoctorUnavailabilityUrl = scheduleId =>
    `${apiVersion}/api/appointment/updateDoctorUnavailability/${scheduleId}/`;

export const deleteDoctorUnavailabilityUrl = scheduleId =>
    `${apiVersion}/api/appointment/deleteDoctorUnavailability/${scheduleId}/`;

export const updateNudgePermissionUrl = id =>
    `${apiVersion}/api/doctor/updateDoctorNudgeDetail/${id}/`;

export const getNudgePermissionUrl = id =>
    `${apiVersion}/api/doctor/getDoctorNudgeDetail/${id}/`;

export const changePasswordUrl = () => `${apiVersion}/api/user/changePassword`;

export const generateTokenUrl = () => `${apiVersion}/api/user/generateToken/`;

export const updateDoctorAppThemeUrl = themeId =>
    `${apiVersion}/api/doctor/updateDoctorAppTheme/${themeId}/`;

export const getDoctorAppThemeUrl = detailId =>
    `${apiVersion}/api/doctor/getDoctorAppTheme/${detailId}/`;

//appointments
export const getAppointmentListUrl = page =>
    `${apiVersion}/api/appointment/getAppointmentList?page=${page}`;

export const updateAppointmentStatusUrl = appointmentId =>
    `${apiVersion}/api/appointment/updateAppointmentStatus/${appointmentId}/`;

export const getAppointmentDetailUrl = appointmentId =>
    `${apiVersion}/api/appointment/getAppointmentDetail/${appointmentId}/`;

export const getDoctorPatientListUrl = (doctorDetailId, page, q) => {
    return `${apiVersion}/api/patient/getDoctorPatientList/${doctorDetailId}/?search=${q}&page=${page}`;
};
export const clearNotificationsUrl = () =>
    `${apiVersion}/api/user/deleteNotification`;

export const markAsReadUrl = () => `${apiVersion}/api/user/markAsRead`;

export const deletePatientPCPDoctorUrl = pcpId =>
    `${apiVersion}/api/patient/deletePatientPCPDoctor/${pcpId}/`;

export const getPatientNotes = (q, page) =>
    `${apiVersion}/api/appointment/getNotes/?search=${q}&page=${page}`;

export const updatePatientNotes = id =>
    `${apiVersion}/api/appointment/updateNotes/${id}/`;

export const deletePatientNotes = id =>
    `${apiVersion}/api/appointment/deleteNotes/${id}/`;

export const addPatientNotes = `${apiVersion}/api/appointment/addNotes`;
export const getAvailablePermissionUrl = id =>
    `${apiVersion}/api/doctor/getDoctorAvailableStatus/${id}/`;

export const updateAvailablePermissionUrl = id =>
    `${apiVersion}/api/doctor/updateDoctorAvailableStatus/${id}/`;

// templates and notes
export const savePatientDetailsUrl = `${apiVersion}/api/patient/addPatientDetails`;
export const getPatientDetailsUrl = id =>
    `${apiVersion}/api/patient/getPatientDetails/${id}/`;
export const updatePatientDetailUrl = id =>
    `${apiVersion}/api/patient/updatePatientDetails/${id}/`;
export const savePatientMedicalRecordsUrl = `${apiVersion}/api/patient/addPatientMedicalRecord/`;
export const updatePatientMedicalRecordsUrl = id =>
    `${apiVersion}/api/patient/updatePatientMedicalRecord/${id}/`;

export const savePatientContactDetailUrl = id =>
    `${apiVersion}/api/patient/updatePatientContactDetails/${id}/`;

export const addNoteTemplateUrl = `${apiVersion}/api/appointment/addTemplate`;

export const getAllNoteTemplateUrl = (q, page) =>
    `${apiVersion}/api/appointment/searchTemplates/?search=${q}&page=${page}`;

export const editNoteTemplateUrl = tempID =>
    `${apiVersion}/api/appointment/updateTemplate/${tempID}/`;

export const delteNotebyId = tempID =>
    `${apiVersion}/api/appointment/deleteTemplate/${tempID}/`;

export const searchNotes = q =>
    `${apiVersion}/api/appointment/searchTemplates/?search=${q}`;

export const addNotesUrl = () => `${apiVersion}/api/appointment/addNotes`;

export const appointmentSessionCreationUrl = () =>
    `${apiVersion}/api/appointment/getSessionDetailsForPatient/`;

export const getDateWiseAppointmentListUrl = page =>
    `${apiVersion}/api/appointment/getDateWiseAppointmentList?page=${page}`;

//settings
export const getBlockedPatients = page =>
    `${apiVersion}/api/patient/getBlockPatientList/?page=${page}`;
export const blockPatientUrl = `${apiVersion}/api/patient/blockPatient/`;
export const unblockPatientUrl = id =>
    `${apiVersion}/api/patient/patientUnblock/${id}/`;

//ongoing call add participants
export const addVisitNowRequestUrl = () => {
    return `${apiVersion}/api/appointment/addVisitNowRequest`;
};

export const searchPhysicians = (q, page) =>
    q ?
    `${apiVersion}/api/doctor/searchDoctor/?search=${q}&page=${page}` :
    `${apiVersion}/api/doctor/searchDoctor/?page=${page}`;

export const getVisitNowRequestUrl = appointmentId => {
    return `${apiVersion}/api/appointment/getVisitNowRequest/${appointmentId}/`;
};

export const updateVisitNowRequestStatusUrl = appointmentId => {
    return `${apiVersion}/api/appointment/updateVisitNowRequestStatus/${appointmentId}/`;
};

export const getCurrentPhysicianUrl = `${apiVersion}/api/doctor/getDoctorDetails/`;

export const addUserLocationUrl = `${apiVersion}/api/user/addUserLocation`;

export const getUserLocationUrl = `${apiVersion}/api/user/getUserLocation/`;

export const updateUserLocationUrl = userId =>
    `${apiVersion}/api/user/updateUserLocation/${userId}/`;

export const updateDrLocationStatusUrl = id =>
    `${apiVersion}/api/doctor/updateDoctorCurrentLocationAddressStatus/${id}/`;

export const updateGuestDoctorRequestUrl = appointmentId => {
    return `${apiVersion}/api/appointment/updateGuestDoctorRequest/${appointmentId}/`;
};

export const getSessionDetailsForPatientUrl = () => {
    return `${apiVersion}/api/appointment/getSessionDetailsForPatient/`;
};

export const addGuestDoctorUrl = appointmentId => {
    return `${apiVersion}/api/appointment/addGuestDoctor/${appointmentId}/`;
};

export const removeGuestDoctorRequestUrl = appointmentId => {
    return `${apiVersion}/api/appointment/removeGuestDoctorRequest/${appointmentId}/`;
};

export const getPatientFilesUrl = (q, page) => {
    return `${apiVersion}/api/patient/getPatientFiles/?search=${q}&page=${page}`;
};
export const addPatientChatAttachmentUrl = () => {
    return `${apiVersion}/api/patient/addPatientChatAttachment`;
};

//account apis
export const getBankDetailsForPhysicianUrl = doctorId => {
    return `${apiVersion}/api/payment/getBankDetailsForPhysician/${doctorId}/`;
};
export const addBankDetailsForPhysicianUrl = () => {
    return `${apiVersion}/api/payment/addBankDetailsForPhysician/`;
};
export const updateAppointmentCompletedStatusUrl = appointmentId => {
    return `${apiVersion}/api/appointment/updateAppointmentCompletedStatus/${appointmentId}/`;
};

export const updateUserRoleUrl = id => {
    return `${apiVersion}/api/user/updateUserRole/${id}/`;
};

export const getUserDetailIdUrl = `${apiVersion}/api/patient/getUserDetailID/`;

export const updateVisitNowRequestUrl = id => {
    return `${apiVersion}/api/appointment/updateVisitNowRequest/${id}/`;
};

export const updateBankDetailsForPhysicianUrl = id => {
    return `${apiVersion}/api/payment/updateBankDetailsForPhysician/`;
};

export const addCardDetailsForPhysicianUrl = () => {
    return `${apiVersion}/api/payment/addCardDetailsForPhysician/`;
};

export const getCustomerCardDetailsUrl = id => {
    return `${apiVersion}/api/payment/getCustomerCardPaymentDetails/${id}/`;
};

export const deleteUserCardDetailsUrl = id => {
    return `${apiVersion}/api/payment/deleteCustomerCardPaymentDetails/${id}`;
};

export const getSubscriptionPlanListForPhysicianUrl = id => {
    return `${apiVersion}/api/payment/getSubscriptionPlanListForPhysician/`;
};

export const addSubscriptionPlanForPhysicianUrl = () => {
    return `${apiVersion}/api/payment/addSubscriptionPlanForPhysician/`;
};

export const updateDoctorStatus = id =>
    `${apiVersion}/api/doctor/updateDoctorStatus/${id}/`;

export const getPatientVitalsUrl = () =>
    `${apiVersion}/api/patient/getPatientVitals/`;

export const attachPaymentMethodUrl = () =>
    `${apiVersion}/api/payment/attachPaymentMethod/`;

export const addACHBankDetailsUrl = () =>
    `${apiVersion}/api/payment/addACHBankDetails/`;

export const oneTimePaymentUrl = () =>
    `${apiVersion}/api/payment/oneTimePayment/`;

export const getCustomerBankDetailsUrl = id =>
    `${apiVersion}/api/payment/getCustomerBankDetails/${id}/`;

export const deleteACHBankDetailsUrl = bankId =>
    `${apiVersion}/api/payment/deleteACHBankDetails/${bankId}/`;

export const getCustomerPaymentHistoryUrl = id =>
    `${apiVersion}/api/payment/getCustomerPaymentHistory/${id}/`;

export const downloadInvoiceUrl = () => {
    return `${apiVersion}/api/doctor/downloadInvoice/`;
};

export const getAllPatientListUrl = (doctorId, page, q) => {
    return `${apiVersion}/api/patient/getAllPatientList/${doctorId}/?search=${q}&page=${page}`;
};
export const cancelSubscriptionUrl = () => {
    return `${apiVersion}/api/payment/cancelSubscription/`;
};

export const getSubscriptionDetailUrl = () => {
    return `${apiVersion}/api/payment/getSubscriptionDetails/`;
};
export const setupIntentUrl = () => {
    return `${apiVersion}/api/payment/setupIntent/`;
};
export const getPaymentDetailsUrl = (q, page) => {
    return `${apiVersion}/api/payment/getPaymentDetails/?search=${q}&page=${page}`;
};
export const placeHoldOnCardUrl = () => {
    return `${apiVersion}/api/payment/placeHoldOnCard/`;
};
export const reviewChartNotificationUrl = visit_now_id => {
    return `${apiVersion}/api/appointment/reviewChartNotification/${visit_now_id}/`;
};
export const getSSOURL = () => {
    return `${apiVersion}/api/user/getSSOURL`;
};
export const addDoctorDoseSpotIDURL = physician_id => {
    return `${apiVersion}/api/doctor/addDoctorDoseSpotID/${physician_id}/`;
};
export const getDoctorByDoseSpotIDURL = () => {
    return `${apiVersion}/api/doctor/getDoctorByDoseSpotID/`;
};
export const captureHoldAmountURL = () => {
    return `${apiVersion}/api/payment/updateHoldAmount/`;
};
export const updateDoctorPaidDetailsURL = doctor_id => {
    return `${apiVersion}/api/doctor/updateDoctorPaidDetails/${doctor_id}/`;
};

export const addPatientDoseSpotIDURL = patient_id => {
    return `${apiVersion}/api/patient/addPatientDoseSpotID/${patient_id}/`;
};

export const getChatDetailsUrl = chatId => {
    return `${apiVersion}/api/chat/getChatDetail/${chatId}/`;
};
export const updateChatDetailUrl = chatId => {
    return `${apiVersion}/api/chat/updateChatMessage/${chatId}/`;
};

//dosespot apis
export const getAccessToken = () => {
    return `${dosespotApiVersion}/webapi/v2/connect/token`;
};
export const addClinician = () => {
    return `${dosespotApiVersion}/webapi/v2/api/clinicians`;
};
export const getPatientPrescriptions = (patientId, startDate, endDate) => {
    return `${dosespotApiVersion}/webapi/v2/api/patients/${patientId}/prescriptions?startDate=${startDate}&endDate=${endDate}`;
};
export const editClinician = clinicianId => {
    return `${dosespotApiVersion}/webapi/v2/api/clinicians/${clinicianId}`;
};

export const addPatient = () => {
    return `${dosespotApiVersion}/webapi/v2/api/patients`;
};
export const editPatientDosespot = patientDosespotId => {
    return `${dosespotApiVersion}/webapi/v2/api/patients${patientDosespotId}`;
};

export const scheduleRunnerUrl = () => {
    return `${apiVersion}/api/user/scheduler-runner`;
};

export const updateConciergeServiceUrl = () => {
    return `${apiVersion}/api/doctor/updateConciergeService`;
};

export const getConciergeServiceUrl = () => {
    return `${apiVersion}/api/doctor/getConciergeService`;
};

export const getSubscribedConciergeServicePatientListUrl = (search, requestStatus, page) => {
    return `${apiVersion}/api/doctor/listSubscribeConciergeServiceRequest?pagination=true&search=${search}&request_status=${requestStatus}&page=${page}`
}

export const getWebsocketUrl = (chatChannel, userAccessToken) => {
    const webSocketBaseUrl = process.env.REACT_APP_WEBSOCKET_URL;
    return `wss://${webSocketBaseUrl}/ws/chat/${chatChannel}/?token=${userAccessToken}`;
};

export const allowDenySubscriptionRequestUrl = (id) => {
    return `${apiVersion}/api/doctor/allowDenySubscribeRequest/${id}`;
};

export const getPreSignedUrl = (filePath) => {
    return `${apiVersion}/api/chat/getPreSignedUrl/?file_path=${filePath}`;
};

export const getReceivedMessagesCountUrl = () => {
    return `${apiVersion}/api/chat/getReceivedMessagesCount/`;
};

export const getActivePatientSubscriptionCountUrl = () => {
    return `${apiVersion}/api/doctor/getActivePatientSubscriptionCount/`;
};